<script setup>

import { inject, watch } from 'vue';
import ElementRapport from './ElementRapport.vue'

const { zone } = defineProps({
	zone: Object
})

const selectionnerElement = inject('selectionnerElement');
const affichageElementsMasques = inject('affichageElementsMasques');

watch(() => zone.selectionPremierElement, (sel) => {
	if (sel) {
		delete zone.selectionPremierElement;
		const premierElementAffiche = zone.elements.find(elt => affichageElementsMasques || !elt.masque);
		if (premierElementAffiche != null) {
			selectionnerElement(premierElementAffiche, zone);
		}
	}
});

watch(() => zone.selectionne, (sel) => {
	if (sel) {
		activerSurbrillanceSousElements();
	} else {
		desactiverSurbrillanceSousElements();
	}
});

function activerSurbrillanceSousElements() {
	zone.elements.forEach(elt => {
		elt.lieASelection = true;
	});
}

function desactiverSurbrillanceSousElements() {
	zone.elements.forEach(elt => {
		delete elt.lieASelection;
	});
}

</script>

<template>
	<div class="zone" 
		:class="{horizontale: zone.orientation == 'HORIZONTALE'}"
		:style="zone.style">
		<ElementRapport v-for="element in zone.elements" 
			:class="{'liee-a-selection': element.lieASelection}"
			:element="element" 
			:parent="zone" />
		<span v-if="zone.elements.length == 0" class="texte-zone-vide">
			<i>( Zone vide )</i>
		</span>
	</div>
</template>

<style scoped>

.zone {
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	border-style: solid;
	border-width: 0px;
}

.horizontale {
	flex-direction: row;
}

.texte-zone-vide {
	user-select: none;
	color: grey;
}

</style>